import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

GoogleRecaptchaForm.propTypes = {
  siteKey: PropTypes.string,
  language: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

GoogleRecaptchaForm.defaultProps = {
  siteKey: process.env.REACT_APP_GOOGLE_RECAPTCHA_V2_SITE_KEY ?? '',
  language: 'vi',
  onSuccess: null,
  onError: null,
};

/**
 *
 * @param {{
 * siteKey: string,
 * language: string,
 * onSuccess: function,
 * onError: function,
 * }} props
 * @returns
 */
function GoogleRecaptchaForm(props) {
  // ---- params ----
  const { siteKey, language, onSuccess, onError } = props;

  return (
    <div>
      <ReCAPTCHA
        className="w-100"
        sitekey={siteKey}
        hl={language}
        onChange={(value) => {
          console.log({ value });
          if (!!value) {
            if (onSuccess) {
              onSuccess();
            }
          }
        }}
        onErrored={() => {
          if (onError) {
            onError();
          }
        }}
      />
    </div>
  );
}

export default GoogleRecaptchaForm;
